const subscription = {
    limit_exceeded: 'Hai raggiunto il limite del tuo piano di abbonamento.',
    get_plan_failed: "Impossibile ottenere il piano di abbonamento per l'inquilino.",
    tenant_suspended: "L'inquilino è sospeso. Si prega di contattare l'amministratore.",
};
export default Object.freeze(subscription);
